"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCreateToJSON = exports.ProductCreateFromJSONTyped = exports.ProductCreateFromJSON = exports.instanceOfProductCreate = void 0;
var runtime_1 = require("../runtime");
var ProductCreateVariantsInner_1 = require("./ProductCreateVariantsInner");
/**
 * Check if a given object implements the ProductCreate interface.
 */
function instanceOfProductCreate(value) {
    var isInstance = true;
    isInstance = isInstance && "styleId" in value;
    isInstance = isInstance && "designCompositeId" in value;
    isInstance = isInstance && "variants" in value;
    return isInstance;
}
exports.instanceOfProductCreate = instanceOfProductCreate;
function ProductCreateFromJSON(json) {
    return ProductCreateFromJSONTyped(json, false);
}
exports.ProductCreateFromJSON = ProductCreateFromJSON;
function ProductCreateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'styleId': json['style_id'],
        'designCompositeId': json['design_composite_id'],
        'enabled': !(0, runtime_1.exists)(json, 'enabled') ? undefined : json['enabled'],
        'variants': (json['variants'].map(ProductCreateVariantsInner_1.ProductCreateVariantsInnerFromJSON)),
    };
}
exports.ProductCreateFromJSONTyped = ProductCreateFromJSONTyped;
function ProductCreateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'style_id': value.styleId,
        'design_composite_id': value.designCompositeId,
        'enabled': value.enabled,
        'variants': (value.variants.map(ProductCreateVariantsInner_1.ProductCreateVariantsInnerToJSON)),
    };
}
exports.ProductCreateToJSON = ProductCreateToJSON;
